import React from 'react';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

const topics = [
  {
    name: 'Geography',
    answers: 254,
    img: 'https://i.imgur.com/c9OOXgJ.png',
  },
  {
    name: 'NBA',
    answers: 178,
    img: 'https://i.imgur.com/pJZ2dmS.png',
  },
  {
    name: 'Ecology',
    answers: 87,
    img: 'https://d1whtlypfis84e.cloudfront.net/guides/wp-content/uploads/2018/03/23213010/ecology-300x168.jpg',
  },
  {
    name: 'Programming',
    answers: 41,
    img: 'https://www.itchronicles.com/wp-content/uploads/2018/10/bigstock-Programming-Web-Banner-Best-P-258081862.jpg',
  },
  {
    name: 'JavaScript',
    answers: 18,
    img: 'https://static.javatpoint.com/images/javascript/javascript_logo.png',
  },
];

function KnowsAbout() {
  return (
    <div className={style.topics}>
      <SectionHeader headingLeft='Knows About' headingRight='' colWidth={12} />
      <div className={`row ${style['row--main']}`}>
        {topics.map((topic, index) => (
          <p className={`col-12 ${style.topic}`} key={index}>
            <span className='row'>
              <span className={`col-1 ${style['topic-icon']}`}>
                <img
                  src={topic.img}
                  alt={topic.name}
                  className={style['topic-img']}
                />
              </span>
              <span className='col-11'>
                <span className={style['topic-text']}>{topic.name}</span>
                <span className={`text-muted ${style['topic-text']}`}>
                  {topic.answers} answers
                </span>
              </span>
            </span>
          </p>
        ))}
        <p className={`text-muted ${style['view-more']}`}>View more</p>
      </div>
    </div>
  );
}

export default KnowsAbout;
